import axios, { AxiosInstance } from 'axios';

import { resolveLeicaIntegrationDomain } from '../../utils/core/endpoints';
import { isDefined } from '../../utils/variables';
import { AuthServiceV1 } from './services/leica/v1/auth-service';
import { SkyMapLeicaConnectionServiceV1 } from './services/leica/v1/skymap-leica-connection-service';

class LeicaAxiosServiceFactory {
  static get instance() {
    if (!isDefined(LeicaAxiosServiceFactory.axiosInstance)) {
      LeicaAxiosServiceFactory._instance.setup();
    }
    return LeicaAxiosServiceFactory._instance;
  }

  /**
   *  Because axiosInstance is not setup until setup(), it is possible undefined.
   */
  private static axiosInstance?: AxiosInstance;

  private static _instance: LeicaAxiosServiceFactory = new LeicaAxiosServiceFactory();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   *  Sets up axios factory.
   */
  setup() {
    LeicaAxiosServiceFactory.axiosInstance = axios.create({
      baseURL: resolveLeicaIntegrationDomain(),
      maxRedirects: 0,
    });

    LeicaAxiosServiceFactory.axiosInstance.interceptors.request.use(
      (value) => value,
      (error) => Promise.reject(error),
    );

    LeicaAxiosServiceFactory.axiosInstance.interceptors.response.use(
      (value) => value,
      (error) => Promise.reject(error),
    );
  }

  createAuthServiceV1() {
    return new AuthServiceV1(LeicaAxiosServiceFactory.axiosInstance!);
  }

  createConnectionServiceV1() {
    return new SkyMapLeicaConnectionServiceV1(LeicaAxiosServiceFactory.axiosInstance!);
  }
}

export { LeicaAxiosServiceFactory };
